import { VueTemplate } from '../VueTemplate';
import { WeatherWidgetTemplateData } from '../../../Widget/WeatherWidget/types';
import { RawTemplate } from '../../types';

/**
 * Template class for weather templates created using Vue
 */
export class VueWeatherTemplate extends VueTemplate<WeatherWidgetTemplateData> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for Weather template must be of this format so that
     * templates are consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties: {
        weather: ObjectConstructor;
        hourly: ArrayConstructor;
        widget: ObjectConstructor;
        metadata: ObjectConstructor;
    } = {
        //Array of quotes
        weather: Object,

        //quotes object
        hourly: Array,

        //reference to the widget object
        widget: Object,

        //Other miscellaneous data
        metadata: Object,
    };

    constructor(template: RawTemplate, wrapper: HTMLElement) {
        super(template, wrapper);
    }

    /**
     * Updates data store with updated weather data
     */
    updateDataStore(context: WeatherWidgetTemplateData): void {
        this.dataStore.weather = context.weather;
        this.dataStore.hourly = context.hourly;
    }
}
